import { useEffect, useState } from "react";
import { Link, Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { useMediaQuery } from "../hooks/useMediaQuery";
import { useTranslations } from "../hooks/useTranslations";
import { useMe } from "../http/serviceportalApi";
import SVGDescription from "../icons/Description.svg?react";
import { checkHasPrivateHouseholdPermission } from "../utils";
import AccountButton from "./AccountButton";
import styles from "./PrivateHouseholdApp.module.css";
import PrivateHouseholdDocuments from "./PrivateHouseholdDocuments";
import Sidebar from "./Sidebar";
import AppMenu from "./ui/AppMenu";
import Hamburger from "./ui/Hamburger";
import LoadingSpinner from "./ui/LoadingSpinner";
import Nav from "./ui/Nav";

const PrivateHouseholdApp = () => {
  const { i18n } = useTranslations();
  const auth = useAuth();
  const matchesMedia = useMediaQuery("(min-width: 1400px)");
  const [isSidebarOpen, setSidebarOpen] = useState(matchesMedia);

  const { data, isValidating } = useMe();
  const userPermissions = data?.permissions ?? [];

  const isPrivateHousehold =
    checkHasPrivateHouseholdPermission(userPermissions);

  const closeMenu = () => {
    !matchesMedia && setSidebarOpen(false);
  };

  useEffect(closeMenu, [matchesMedia]);

  if (!auth.session || !isPrivateHousehold) {
    return null;
  }

  return isValidating ? (
    <div className={styles.loadingSpinner}>
      <LoadingSpinner />
    </div>
  ) : (
    <>
      <header className={styles.header}>
        <div className={styles.aside}>
          <Hamburger
            isOpen={isSidebarOpen}
            className={styles.hamburger}
            onClick={() => setSidebarOpen(!isSidebarOpen)}
          />
          <Link to="/privathaushalt" className={styles.logo}>
            {i18n.privateHouseholdApp.title}
          </Link>
        </div>
        <AppMenu />
        <AccountButton />
      </header>
      <div>
        <Sidebar isOpen={isSidebarOpen} close={closeMenu}>
          <Nav>
            <Nav.Item
              text={i18n.documents.title}
              to="dokumente"
              icon={SVGDescription}
              onClick={closeMenu}
            />
          </Nav>
        </Sidebar>
        <Routes>
          <Route path="dokumente/*" element={<PrivateHouseholdDocuments />} />
          <Route path="*" element={<Navigate to="dokumente" replace />} />
        </Routes>
      </div>
    </>
  );
};

export default PrivateHouseholdApp;
